import React from 'react';
import { Pagination } from '@mantine/core';
import UsageRightTable from './UsageRightTable/UsageRightTable';
import { useUsageRight } from './UsageRightsProvider';
import styles from '../../../styles/usageRights.module.css';
import LoaderSvg from '../../../assets/images/loader.svg';
import UsageRightModal from './UsageRightModal/UsageRightModal';
import FilterChip from './FilterChip';
import UsageRightsFtux from './UsageRightsFtux';
import UsageRightCards from './UsageRightCard/UsageRightCards';

function UsageRightsContent() {
  const {
    isLoadingUsageRights,
    setSelectedRequest,
    selectedRequest,
    pageCount,
    changePage,
    currentPage,
    status,
    clearAndRefetch,
    currentData,
  } = useUsageRight();

  if (isLoadingUsageRights)
    return (
      <div className={styles.usageRightLoaderContainer}>
        <img src={LoaderSvg} alt="loader" width={100} />
      </div>
    );

  if (currentData?.length === 0)
    return (
      <>
        {status && <FilterChip status={status} onCrossClick={clearAndRefetch} />}
        <UsageRightsFtux />
      </>
    );

  return (
    <>
      {status && <FilterChip status={status} onCrossClick={clearAndRefetch} />}
      <div className={styles.usageRightTableContainer}>
        <UsageRightTable />
      </div>
      <div className={styles.usageRightTableCardContainer}>
        <UsageRightCards />
      </div>
      {pageCount > 1 && (
        <div className={styles.paginationContainer}>
          <Pagination total={pageCount} value={currentPage} onChange={changePage} radius="md" color="violet" />
        </div>
      )}
      <UsageRightModal
        request={selectedRequest}
        open={Boolean(selectedRequest)}
        onClose={() => setSelectedRequest(null)}
      />
    </>
  );
}

export default UsageRightsContent;
